<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 34.478 31.205"
  >
    <defs>
      <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
        <stop offset="0" stop-color="#de4551" stop-opacity="0" />
        <stop offset="1" stop-color="#de4551" />
      </linearGradient>
    </defs>
    <g id="Group_148" data-name="Group 148" transform="translate(-1.973 -40.752)">
      <path
        id="Path_749"
        data-name="Path 749"
        d="M66.371,129.9H38.016a1.586,1.586,0,0,0-1.586,1.586v15.344a1.585,1.585,0,0,0,1.19,1.534v.856a1.585,1.585,0,0,0,1.19,1.534v.823c0,.051,0,.1.007.151a1.585,1.585,0,0,0,1.579,1.436h23.6a1.585,1.585,0,0,0,1.579-1.436c0-.05.007-.1.007-.151v-.823a1.586,1.586,0,0,0,1.19-1.534v-.856a1.586,1.586,0,0,0,1.19-1.534V131.487A1.586,1.586,0,0,0,66.371,129.9Z"
        transform="translate(-34.457 -82.352)"
        opacity="0.1"
        fill="url(#linear-gradient)"
        style="isolation: isolate"
      />
      <path
        id="Path_750"
        data-name="Path 750"
        d="M114.028,290.789v5.826c0,.051,0,.1-.007.151a1.585,1.585,0,0,1-1.579,1.436h-23.6a1.585,1.585,0,0,1-1.579-1.436c0-.05-.007-.1-.007-.151v-5.826a1.586,1.586,0,0,1,1.586-1.586h23.6A1.586,1.586,0,0,1,114.028,290.789Z"
        transform="translate(-81.256 -229.018)"
        fill="#fff"
      />
      <path
        id="Path_751"
        data-name="Path 751"
        d="M99.821,213.238H73.846a1.586,1.586,0,0,1-1.586-1.586V201.066a1.586,1.586,0,0,1,1.586-1.586H99.821a1.586,1.586,0,0,1,1.586,1.586v10.585A1.586,1.586,0,0,1,99.821,213.238Z"
        transform="translate(-67.445 -146.412)"
        fill="#fff"
      />
      <path
        id="Path_752"
        data-name="Path 752"
        d="M87.2,127.863H58.846a1.586,1.586,0,0,1-1.586-1.586V110.932a1.586,1.586,0,0,1,1.586-1.586H87.2a1.586,1.586,0,0,1,1.586,1.586v15.344A1.586,1.586,0,0,1,87.2,127.863Z"
        transform="translate(-53.635 -63.427)"
        fill="#fff"
      />
      <path
        id="Path_753"
        data-name="Path 753"
        d="M119.135,151.927v4.051a.4.4,0,0,1-.286.381,4.579,4.579,0,0,0-3.151,3.493.394.394,0,0,1-.389.315H97.156a.394.394,0,0,1-.389-.315,4.579,4.579,0,0,0-3.151-3.493.4.4,0,0,1-.286-.381v-4.051a.4.4,0,0,1,.286-.381,4.579,4.579,0,0,0,3.151-3.493.394.394,0,0,1,.389-.315h18.153a.394.394,0,0,1,.389.315,4.579,4.579,0,0,0,3.151,3.493.4.4,0,0,1,.286.381Z"
        transform="translate(-86.844 -98.775)"
        fill="#f0324c"
      />
      <ellipse
        id="Ellipse_235"
        data-name="Ellipse 235"
        cx="4.006"
        cy="5.091"
        rx="4.006"
        ry="5.091"
        transform="translate(15.383 50.086)"
        fill="#fff"
      />
      <g id="Group_147" data-name="Group 147" transform="translate(3.228 45.522)">
        <path
          id="Path_754"
          data-name="Path 754"
          d="M156.7,276.78h-1.73a.4.4,0,0,1,0-.793h1.73a.4.4,0,0,1,0,.793Z"
          transform="translate(-146.462 -262.373)"
          fill="#2f3042"
        />
        <path
          id="Path_755"
          data-name="Path 755"
          d="M327.738,166.947h-1.73a.4.4,0,1,1,0-.793h1.73a.4.4,0,1,1,0,.793Z"
          transform="translate(-303.929 -161.252)"
          fill="#2f3042"
        />
        <g id="Group_145" data-name="Group 145" transform="translate(7.196 9.212)">
          <circle
            id="Ellipse_236"
            data-name="Ellipse 236"
            cx="0.443"
            cy="0.443"
            r="0.443"
            transform="translate(0)"
            fill="#2f3042"
          />
          <circle
            id="Ellipse_237"
            data-name="Ellipse 237"
            cx="0.443"
            cy="0.443"
            r="0.443"
            transform="translate(1.341)"
            fill="#2f3042"
          />
          <circle
            id="Ellipse_238"
            data-name="Ellipse 238"
            cx="0.443"
            cy="0.443"
            r="0.443"
            transform="translate(2.683)"
            fill="#2f3042"
          />
          <circle
            id="Ellipse_239"
            data-name="Ellipse 239"
            cx="0.443"
            cy="0.443"
            r="0.443"
            transform="translate(14.358)"
            fill="#2f3042"
          />
          <circle
            id="Ellipse_240"
            data-name="Ellipse 240"
            cx="0.443"
            cy="0.443"
            r="0.443"
            transform="translate(15.7)"
            fill="#2f3042"
          />
          <circle
            id="Ellipse_241"
            data-name="Ellipse 241"
            cx="0.443"
            cy="0.443"
            r="0.443"
            transform="translate(17.041)"
            fill="#2f3042"
          />
        </g>
        <path
          id="Path_756"
          data-name="Path 756"
          d="M406.3,149.343a.4.4,0,0,1-.28-.677l1.4-1.4a.4.4,0,0,1,.561.561l-1.4,1.4a.4.4,0,0,1-.28.116Z"
          transform="translate(-377.858 -143.754)"
          fill="#2f3042"
        />
        <path
          id="Path_757"
          data-name="Path 757"
          d="M393.82,135.509a.4.4,0,0,1-.28-.677l1.4-1.4a.4.4,0,0,1,.561.561l-1.4,1.4A.4.4,0,0,1,393.82,135.509Z"
          transform="translate(-366.363 -131.017)"
          fill="#2f3042"
        />
        <path
          id="Path_758"
          data-name="Path 758"
          d="M91.3,293.354a.4.4,0,0,1-.28-.677l1.4-1.4a.4.4,0,0,1,.561.561l-1.4,1.4A.4.4,0,0,1,91.3,293.354Z"
          transform="translate(-87.843 -276.342)"
          fill="#2f3042"
        />
        <path
          id="Path_759"
          data-name="Path 759"
          d="M78.82,279.521a.4.4,0,0,1-.28-.677l1.4-1.4A.4.4,0,0,1,80.5,278l-1.4,1.4A.4.4,0,0,1,78.82,279.521Z"
          transform="translate(-76.348 -263.607)"
          fill="#2f3042"
        />
        <path
          id="Path_760"
          data-name="Path 760"
          d="M84.184,117.838a.4.4,0,0,0,.4-.4V106.329a1.985,1.985,0,0,0-1.983-1.983H54.243a1.985,1.985,0,0,0-1.983,1.983v15.344a1.985,1.985,0,0,0,1.19,1.817v.573a1.983,1.983,0,0,0,1.19,1.818v.54a1.985,1.985,0,0,0,1.983,1.983h23.6a1.985,1.985,0,0,0,1.983-1.983v-.54a1.982,1.982,0,0,0,1.19-1.817v-.573a1.986,1.986,0,0,0,1.19-1.817v-2a.4.4,0,1,0-.793,0v2a1.191,1.191,0,0,1-1.19,1.19H54.243a1.191,1.191,0,0,1-1.19-1.19V106.329a1.191,1.191,0,0,1,1.19-1.19H82.6a1.191,1.191,0,0,1,1.19,1.19v11.113A.4.4,0,0,0,84.184,117.838ZM82.6,123.656v.407a1.189,1.189,0,0,1-.892,1.152,1.2,1.2,0,0,1-.3.038H57.321a.4.4,0,1,0,0,.793H81.408v.375a1.191,1.191,0,0,1-1.19,1.19h-23.6a1.191,1.191,0,0,1-1.19-1.19V125.6a.4.4,0,0,0-.3-.384,1.189,1.189,0,0,1-.892-1.152v-.407Z"
          transform="translate(-52.26 -104.346)"
          fill="#2f3042"
        />
        <path
          id="Path_761"
          data-name="Path 761"
          d="M111.484,143.375a.791.791,0,0,0-.778-.635H92.553a.792.792,0,0,0-.778.635,4.163,4.163,0,0,1-2.878,3.189.792.792,0,0,0-.567.76v4.051a.792.792,0,0,0,.567.76,4.163,4.163,0,0,1,2.878,3.189.791.791,0,0,0,.778.635h18.153a.791.791,0,0,0,.778-.635,4.163,4.163,0,0,1,2.878-3.189.792.792,0,0,0,.567-.76v-4.051a.792.792,0,0,0-.567-.76,4.163,4.163,0,0,1-2.878-3.189Zm2.646,8a4.955,4.955,0,0,0-3.424,3.79l-18.152.006a4.956,4.956,0,0,0-3.43-3.8l.005-4.052a4.955,4.955,0,0,0,3.424-3.79l18.152-.006a4.962,4.962,0,0,0,3.43,3.8Z"
          transform="translate(-85.469 -139.695)"
          fill="#2f3042"
        />
        <g id="Group_146" data-name="Group 146" transform="translate(14.2 7.697)">
          <path
            id="Path_762"
            data-name="Path 762"
            d="M234.8,203.6h-.069v-.515h.069a.354.354,0,0,0,.291-.143.55.55,0,0,0,0-.667.352.352,0,0,0-.291-.144h-.069v-.339a.393.393,0,0,0-.125-.283.469.469,0,0,0-.64,0,.393.393,0,0,0-.125.283v.339h-.818l-.376-.562a.407.407,0,0,0-.362-.186.435.435,0,0,0-.32.125.39.39,0,0,0-.126.285v.339h-.154a.352.352,0,0,0-.291.144.55.55,0,0,0,0,.667.354.354,0,0,0,.291.143h.154v.515h-.154a.354.354,0,0,0-.291.144.551.551,0,0,0,0,.668.354.354,0,0,0,.291.143h.154v.341a.385.385,0,0,0,.126.282.434.434,0,0,0,.32.125.429.429,0,0,0,.319-.125.387.387,0,0,0,.125-.282v-.341h.817l.377.562a.414.414,0,0,0,.365.186.432.432,0,0,0,.319-.125.387.387,0,0,0,.125-.282v-.341h.069a.354.354,0,0,0,.291-.143.551.551,0,0,0,0-.668A.354.354,0,0,0,234.8,203.6Zm-2.071,0v-.263l.176.263Zm1.113-.249-.178-.266h.178Z"
            transform="translate(-231.28 -201.38)"
            fill="#2f3042"
          />
        </g>
      </g>
      <path
        id="Path_763"
        data-name="Path 763"
        d="M39.455,373.6H39.2v-.258a.4.4,0,1,0-.793,0v.258h-.258a.4.4,0,1,0,0,.793H38.4v.258a.4.4,0,1,0,.793,0V374.4h.258a.4.4,0,1,0,0-.793Z"
        transform="translate(-35.673 -306.122)"
        fill="#f0324c"
      />
      <path
        id="Path_764"
        data-name="Path 764"
        d="M134.414,70.487h-.258V70.23a.4.4,0,0,0-.793,0v.258h-.258a.4.4,0,1,0,0,.793h.258v.258a.4.4,0,1,0,.793,0v-.258h.258a.4.4,0,1,0,0-.793Z"
        transform="translate(-123.1 -27.048)"
        fill="#f0324c"
      />
      <path
        id="Path_765"
        data-name="Path 765"
        d="M446.309,381.614h-.258v-.258a.4.4,0,0,0-.793,0v.258H445a.4.4,0,1,0,0,.793h.258v.258a.4.4,0,0,0,.793,0v-.258h.258a.4.4,0,0,0,0-.793Z"
        transform="translate(-410.256 -313.497)"
        fill="#f0324c"
      />
      <path
        id="Path_766"
        data-name="Path 766"
        d="M436.155,46.523a1.162,1.162,0,0,1-.345-.053,1.151,1.151,0,1,1,.345.053Zm0-1.524a.366.366,0,1,0,.109.017A.363.363,0,0,0,436.153,45Z"
        transform="translate(-401.408 -3.453)"
        fill="#f0324c"
      />
      <path
        id="Path_767"
        data-name="Path 767"
        d="M61.978,410.731a1.158,1.158,0,1,1,1.107-.814A1.154,1.154,0,0,1,61.978,410.731Zm0-1.523a.365.365,0,1,0,.108.016A.366.366,0,0,0,61.979,409.207Zm.727.591h0Z"
        transform="translate(-56.913 -338.774)"
        fill="#f0324c"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-8'
    },
    height: {
      type: String,
      default: 'h-6'
    }
  }
}
</script>
